import { render, staticRenderFns } from "./plan-block-price-features.vue?vue&type=template&id=44340644"
import script from "./plan-block-price-features.vue?vue&type=script&lang=js"
export * from "./plan-block-price-features.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports